import React, { useRef, useState, useEffect } from 'react'
import ReactModal from 'react-modal'
import { ReactComponent as CloseModalIcon } from '../../svg/normalSvgs/CloseModalIcon.svg'
import ConnectToDummoBackground from '../../svg/normalSvgs/ConnectToDummoBackground.svg'
import TransferDumoBackground from '../../svg/normalSvgs/TransferDumoBackground.svg'
import TransferPointsBackground from '../../svg/normalSvgs/TransferPointsBackground.png'
import { ReactComponent as ConnectToDummoLogo } from '../../svg/normalSvgs/ConnectToDummoLogo.svg'
import { ReactComponent as TransferDumoLogo } from '../../svg/normalSvgs/TransferDumoLogo.svg'
import { ReactComponent as DummoPointsLogo } from '../../svg/normalSvgs/DummoPointsLogo.svg'
import '../../styles/modals/ConnectToDummoModal.css'
import { useTranslation } from 'react-i18next'

function ConnectToDummoModal({ modalIsOpen, closeModal, confirmation, unlinkUserAccount }) {
    const { t, locale } = useTranslation()
    const [account, setAccount] = useState('')
    const [modalState, setModalState] = useState('connect')
    const [points, setPoints] = useState(0)

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('feedid').style.filter = 'blur(5px)'
        } else {
            document.getElementById('feedid').style.filter = 'unset'
        }
    }, [modalIsOpen])

    return (
        <ReactModal
            transparent
            closeTimeoutMS={600}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {
                setModalState('connect')
            }}
            onRequestClose={closeModal}
            className="student-feedback-no-scroll"
            style={{
                overlay: {
                    zIndex: 4,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 650,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'scroll',
                    paddingTop: 35,
                    paddingBottom: 35,
                },
            }}
        >
            <div
                className="connect-to-dummo-container"
                style={{
                    backgroundImage:
                        modalState === 'connect'
                            ? `url(${ConnectToDummoBackground})`
                            : modalState === 'transfer'
                            ? `url(${TransferDumoBackground})`
                            : `url(${TransferPointsBackground})`,
                }}
            >
                <div className="connect-to-dummo-close-button" onClick={() => closeModal()}>
                    <CloseModalIcon />
                </div>
                {modalState === 'connect' && (
                    <div className="connect-to-dummo-body">
                        <div>
                            <ConnectToDummoLogo />
                        </div>
                        <div className="connect-to-dummo-title">{t('Hi, connect your Dummo account')}</div>
                        <div className="connect-to-dummo-form">
                            <div className="connect-to-dummo-inner">
                                <div className="connect-to-dummo-form-label">{t('Write your Dummo username below')}</div>
                                <div className="connect-to-dummo-form-input">
                                    <input
                                        type="text"
                                        placeholder={t('Enter your DUMO username')}
                                        value={account}
                                        onChange={(e) => setAccount(e.target.value)}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="connect-to-dummo-buttons-container">
                            <button className="connect-to-dummo-cancel-button" onClick={() => closeModal()}>
                                {t('cancel')}
                            </button>
                            <button className="connect-to-dummo-button" onClick={() => setModalState('transfer')}>
                                {t('Confirm')}
                            </button>
                        </div>
                    </div>
                )}
                {modalState === 'transfer' && (
                    <div className="connect-to-dummo-body">
                        <div style={{ marginTop: 134 }}>
                            <TransferDumoLogo />
                        </div>
                        <div className="connect-to-dummo-title">{t('Dummo account successfully connected')}</div>
                        <div className="connect-to-dummo-buttons-container" style={{ marginTop: 110 }}>
                            <button className="connect-to-dummo-cancel-button" onClick={() => closeModal()}>
                                {t('close')}
                            </button>
                            <button className="connect-to-dummo-button" onClick={() => setModalState('points')}>
                                {t('Transfer points')}
                            </button>
                        </div>
                    </div>
                )}
                {modalState === 'points' && (
                    <div className="connect-to-dummo-body">
                        <div className="connect-to-dumo-form-points-input" style={{ marginTop: 116, marginLeft: 53 }}>
                            <input type="number" placeholder={t('0')} value={points} onChange={(e) => setPoints(e.target.value)} autoComplete="off" />
                        </div>
                        <div style={{ marginTop: 5, marginRight: 120 }}>
                            <DummoPointsLogo />
                        </div>
                        <div className="connect-to-dummo-title" style={{ color: '#413F5E', marginTop: 40 }}>
                            {t('Dummo points successfully transfered')}
                        </div>
                        <div className="connect-to-dummo-buttons-container" style={{ marginTop: 110 }}>
                            <button className="connect-to-dummo-cancel-button" onClick={() => unlinkUserAccount()}>
                                {t('close')}
                            </button>
                            <button className="connect-to-dummo-button" onClick={() => setModalState('points')}>
                                {t('Transfer points')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </ReactModal>
    )
}

export default ConnectToDummoModal
